import { render, staticRenderFns } from "./select-field-pop.vue?vue&type=template&id=36bac4b0&"
import script from "./select-field-pop.vue?vue&type=script&lang=js&"
export * from "./select-field-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "select-field-pop.vue"
export default component.exports